const BR_DATE_TIME_RE = /^(\d{1,2})\/(\d{1,2})\/(\d{4})\s+(\d{1,2}):(\d{2})(?::(\d{2}))?$/;
const ISO_DATE_TIME_RE = /^(\d{4})-(\d{2})-(\d{2})[T\s](\d{1,2}):(\d{2})(?::(\d{2}))?$/;

export function parseScheduledAt(value) {
  if (!value) return { date: '', time: '' };
  const str = String(value).trim();
  const brMatch = str.match(BR_DATE_TIME_RE);
  if (brMatch) {
    const [, d, m, y, h, min] = brMatch;
    return {
      date: `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`,
      time: `${h.padStart(2, '0')}:${min}`,
    };
  }
  const isoMatch = str.match(ISO_DATE_TIME_RE);
  if (isoMatch) {
    const [, y, m, d, h, min] = isoMatch;
    return {
      date: `${y}-${m}-${d}`,
      time: `${h.padStart(2, '0')}:${min}`,
    };
  }
  return { date: '', time: '' };
}

export function buildScheduledAt(date, time) {
  if (!date || !time) return null;
  return `${date} ${time}:00`;
}

export function formatDateInput(iso) {
  if (!iso) return '';
  const [y, m, d] = String(iso).split('-');
  if (!y || !m || !d) return '';
  return `${d}/${m}/${y}`;
}

export function maskDateInput(raw) {
  const digits = String(raw || '').replace(/\D/g, '').slice(0, 8);
  const parts = [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4, 8)].filter((p) => p !== '');
  return parts.join('/');
}

export function parseDateInput(raw) {
  const digits = String(raw || '').replace(/\D/g, '').slice(0, 8);
  if (digits.length !== 8) return '';
  return `${digits.slice(4, 8)}-${digits.slice(2, 4)}-${digits.slice(0, 2)}`;
}

export function maskTimeInput(raw) {
  const digits = String(raw || '').replace(/\D/g, '').slice(0, 4);
  if (!digits) return '';
  if (digits.length <= 2) return digits;
  return `${digits.slice(0, 2)}:${digits.slice(2, 4)}`;
}

export function formatScheduledAt(value) {
  if (!value) return '';
  const { date, time } = parseScheduledAt(value);
  if (!date) return String(value);
  const [y, m, d] = date.split('-');
  return `${d}/${m}/${y} às ${time}`;
}

export function formatDateBr(value) {
  if (!value) return '';
  const { date } = parseScheduledAt(value);
  if (!date) return String(value);
  const [y, m, d] = date.split('-');
  return `${d}/${m}/${y}`;
}

export function isScheduledAtExpired(value) {
  if (!value) return false;
  const { date, time } = parseScheduledAt(value);
  if (!date || !time) return false;
  const scheduled = new Date(`${date}T${time}:00`);
  if (Number.isNaN(scheduled.getTime())) return false;
  return scheduled.getTime() <= Date.now();
}

export function getChapterStatus(chapter) {
  return chapter.status || (chapter.published ? 'publicado' : 'rascunho');
}